import { useContext } from 'react';
import secure from 'assets/about/secure.png';
import unlimited from 'assets/about/unlimited.png';
import seamless from 'assets/about/seamless.png';
import direct from 'assets/about/direct.png';
import call from 'assets/about/call.png';
import email from 'assets/about/email.png';
import rescalert_small from 'assets/about/rescalert_small.png';
import customweather_logo_wide from 'assets/about/customweather_logo_wide.png';
import { ColorContext } from 'App';

export default function About() {
  const imgStyle = {
    width: 50,
    height: 50,
    marginRight: 20,
  };

  const theme = useContext(ColorContext);

  return (
    <div className="w-100 h-100 d-flex flex-column justify-content-between overflow-auto mt-3">
      {/*header*/}
      <div
        className="d-flex justify-content-between"
        style={{
          marginBottom: 20,
        }}
      >
        <div>
          <h2>About RescAlert</h2>
        </div>

        <img src={rescalert_small} alt="rescalert_small" style={imgStyle} />
      </div>

      <h3>What makes us different from others!</h3>
      <p
        style={{
          width: '80%',
        }}
      >
        Our platform doesn't replace your existing system, it makes it better! Each organization
        continues to use their day-to-day platforms they know and trust. When it's time for the
        organization to respond to an emergency, RescAlert's Fusion+ connects them together in
        real-time
      </p>
      <div className="d-flex" style={{ marginTop: 7.662 }}>
        <img src={secure} alt="secure" style={imgStyle} />
        <div className="d-flex flex-column">
          <h3>Secure API</h3>
          <p>Our Open API allows for essentially unlimited integrations.</p>
        </div>
      </div>
      <div className="d-flex" style={{ marginTop: 7.662 }}>
        <img src={unlimited} alt="secure" style={imgStyle} />
        <div className="d-flex flex-column">
          <h3>Unlimited Resources</h3>
          <p>
            Fusion+ is designed to integrate with any database and perform two-way synchronization.
          </p>
        </div>
      </div>
      <div className="d-flex" style={{ marginTop: 7.662 }}>
        <img src={seamless} alt="seamless" style={imgStyle} />
        <div className="d-flex flex-column">
          <h3>Seamless Integration</h3>
          <p>Integrates with each organization's existing day-to-day system.</p>
        </div>
      </div>
      <div className="d-flex" style={{ marginTop: 7.662, marginBottom: 30 }}>
        <img src={direct} alt="secure" style={imgStyle} />
        <div className="d-flex flex-column">
          <h3>Direct Communication</h3>
          <p>Send alerts and messages to the people in your area and those just passing through.</p>
        </div>
      </div>
      <div className="d-flex flex-column" style={{ gap: 20 }}>
        <h2>About Fusion+</h2>
        <p>
          Overwatch Fusion+ is an advanced platform that unifies devices and systems into a cohesive
          interface, leveraging AI to enhance emergency management. It integrates data from sensors,
          cameras, communication devices, and monitoring systems, providing real-time insights and
          predictive analytics. By consolidating this information, Overwatch Fusion+ improves
          decision-making and response efficiency, eliminating the need to switch between systems
          and ensuring streamlined emergency management.
        </p>
        <a
          className="fw-bold ms-1"
          style={{ color: theme.primary }}
          href="https://overwatch.ai/our-company/about-us"
          target="_blank"
          rel="noreferrer"
        >
          https://overwatch.ai/our-company/about-us
        </a>
      </div>
      <div>
        <div style={{ marginTop: 20 }}>
          <div>
            <p className="fw-bold">Contact Us Now</p>
            <div
              className="d-flex justify-content-between w-100 flex-column flex-lg-row gap-5"
              style={{ marginTop: 20 }}
            >
              <div className="d-flex justify-content-between flex-column flex-sm-row gap-5">
                <div style={{ marginRight: 70 }}>
                  <img
                    src={call}
                    alt="call"
                    style={{
                      width: 50,
                      height: 50,
                      marginRight: 20,
                    }}
                  />
                  <h3>Call Us</h3>
                  <a className="fw-bold" style={{ color: theme.fontColor }} href="tel:+18508609824">
                    +1.850.860.9824
                  </a>
                </div>
                <div>
                  <img
                    src={email}
                    alt="email"
                    style={{
                      width: 50,
                      height: 50,
                      marginRight: 20,
                    }}
                  />{' '}
                  <h3>Email Us</h3>
                  <a
                    className="fw-bold"
                    style={{ color: theme.fontColor }}
                    href="mailto:sales.info@rescalert.com"
                  >
                    sales.info@rescalert.com
                  </a>
                </div>
              </div>
              <div className="text-end">
                <div>
                  <img
                    src={customweather_logo_wide}
                    alt="customweather_logo_wide"
                    style={{
                      width: 180,
                      height: 40,
                      marginRight: 20,
                    }}
                  />
                </div>
                <a
                  style={{ color: theme.primary }}
                  href="https://www.customweather.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  https://www.customweather.com/
                </a>
                <div className="mt-2">Weather Data provided by Custom Weather.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
